import axios from "axios";
import api from "../lib/api";
const BASE = import.meta.env.VITE_APP_STREAM_SERVER;

export const CreateArchival = (payload: any) =>
  api.post("/api/archival/user/create-archival", payload);

export const archivalApprovedAndReject = (payload: any) =>
  api.post("/api/archival/action", payload);

export const getVideoV2 = (payload:any) =>
  api.post(`/api/archival/get-video`,payload);

export const getVideo = (payload: any) =>
  axios.post(`${BASE}/api/stream`, payload);

export const approveArchivalRequest = (payload: any) =>
  api.post("/api/archival/admins/approve-archival", payload);
